
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "NMONADGA",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NMONADGA.vue